export const coursesTableColumns = [
	{
		id: 'course',
		label: 'Course',
	},
	{
		id: 'category',
		label: 'Category',
	},
	{
		id: 'rating',
		label: 'Rating',
	},
	{
		id: 'lastUpdated',
		label: 'Last Updated',
	},

	{
		id: 'status',
		label: 'Status',
	},
	{
		id: 'options',
		label: 'Options',
	},
];
